import Repository from '@/libs/axios'

const approvalSettingsResource = '/admin/approvals/request'

const defaultPagination = 10
export default {
  getProfileUpdateSettingTypes(groupId, pageNumber = 1, pagination = defaultPagination) {
    return Repository.get(`${approvalSettingsResource}/get-types?group_id=${groupId}&paginate=${pagination}&page=${pageNumber}`)
  },
  statusAction(payload) {
    return Repository.post(`${approvalSettingsResource}/types-status/update`, payload)
  },
  changeProfileUpdateStatus(payload) {
    return Repository.post(`${approvalSettingsResource}/group-status/update`, payload)
  },
  getGroupStatus(groupId) {
    return Repository.get(`${approvalSettingsResource}/get-group/${groupId}`)
  },
  fetchDataForApprovalRequestTypesNoPagination(groupId) {
    return Repository.get(`${approvalSettingsResource}/get-types?group_id=${groupId}&noPagination=true`)
  },
}
